import { render } from "./Quotations4.vue?vue&type=template&id=0758a581"
import script from "./Quotations4.vue?vue&type=script&lang=js"
export * from "./Quotations4.vue?vue&type=script&lang=js"
script.render = render

export default script